







































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Module } from '@/interfaces/Module';
import { Step } from '@/interfaces/Step';
import ModuleStepListStepActivatorPickStepRequirements from '@/views/ModulePage/ModuleStepListStepActivatorPickStepRequirements.vue';

@Component({
  components: {
    ModuleStepListStepActivatorPickStepRequirements
  }
})
export default class ModuleStepListStepActivator extends Vue {
  @Prop()
  cutoverplan!: Cutoverplan;

  @Prop()
  module!: Module;

  @Prop()
  restrictedUser!: any;

  @Prop()
  step!: Step;
}
